module.exports = __webpack_public_path__ + "school/img/h5bg.d8dbb259.jpg";